var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_8965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9995 10.8418C7.63193 10.8418 7.33398 11.1398 7.33398 11.5073C7.33398 11.8749 7.63193 12.1729 7.9995 12.1729C8.36706 12.1729 8.66501 11.8749 8.66501 11.5073C8.66501 11.1398 8.36706 10.8418 7.9995 10.8418Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75488 6.07188C5.75488 4.83206 6.75997 3.82698 7.99979 3.82698C9.23961 3.82698 10.2447 4.83206 10.2447 6.07188C10.2449 6.99952 9.68309 7.79588 8.88072 8.13843C8.3426 8.36816 7.99979 8.91931 7.99979 9.50439",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.25,
    stroke: "#424242",
    strokeWidth: 1.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_8965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarFaqIcon);
export default __webpack_public_path__ + "static/media/sidebar-faq-icon.bed7a26b5dcbf250353cf74908c4ce73.svg";
export { ForwardRef as ReactComponent };